import PingOneIcon from 'components/core/icons/pingone.svg'
import Image from 'components/core/image'

const PingOne = (): React.ReactElement => {
    return <Image src={PingOneIcon.src} height={24} width={24} />
}

export default PingOne
